import { makeVar, useReactiveVar } from '@apollo/client';
import { User } from 'graphql/types';

type SetLoggedUser = (user: User) => void;

export const user = makeVar<User | null>(null);

function setLoggedUser(loggedUser: User): void {
  user(loggedUser);
}

export function useLoggedUser(): [User | null, SetLoggedUser] {
  const loggedUser = useReactiveVar(user);

  return [loggedUser, setLoggedUser];
}
